module.exports = __webpack_public_path__ + "img/pytorch.e8009e13.svg";